<template>
    <div>
        <h1>Your Carbon Footprint</h1>
        <h3 id="carInvalidWarning" v-if="invalidCar">Trip not possible by car. Are you trying to drive across an ocean? Calculating as a straight line.</h3>
        <div id="estimateExplanation">Calculations are a best estimate based on round-trip travel, using a single mode of transportation.</div>
        <ul id="calculatedValues">
            <li class="calculated-item" id="calcTravel">
                <div class="calculated-icon">
                    <i :class="{fas:true, 'fa-rotate-270': formTravel === 'airplane', 'fa-plane': formTravel === 'airplane', 'fa-car-side': formTravel === 'car'}"></i>
                    <div class="icon-caption" v-if="calculations_done"><span class="calc-value">{{Math.round(miles)}}</span> MI</div>
                    <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                </div>
            </li>
            <li class="calculated-item" id="calcDistance">
                <div class="calculated-icon">
                    <i class="fas fa-cloud"></i>
                    <div class="co2-overlay">CO2</div>
                    <div class="icon-caption" v-if="calculations_done"><span class="calc-value">{{Math.round(lbsCo2)}}</span> LBS</div>
                    <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                </div>
            </li>
            <li class="calculated-item" id="calcOffsetCost">
                <div class="calculated-icon">
                    <i class="fas fa-tree"></i>
                    <div class="icon-caption" v-if="calculations_done"><span class="calc-value">{{Math.round(trees)}}</span> Trees</div>
                    <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                </div>
            </li>
        </ul>
        <div id="calculatedOffsetCostWrap" ref="offsetCostWrap" :style="{transform: 'scale(' + getOffsetCostWrapScale() + ')'}">
            <div class="calculated-icon" ref="offsetCostIcon">
                <div id="calculatedOffsetIcon"><i class="fas fa-cloud"></i>
                    <div class="dollar-overlay">$</div>
                </div>
            </div>
            <div id="calculatedOffsetCost" ref="offsetCostText">
                <div id="calculatedOffsetTotal" v-if="calculations_done">${{roundToDecimal(offsetCost, 2).toFixed(2)}}</div>
                <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                <div id="calculatedOffsetSubtitle">Total Offset Cost</div>
            </div>
        </div>
<!--        <div id="project">-->
<!--            <p>You have the opportunity to contribute to a specific project on tribal land.</p>-->
<!--            <label for="projectSelect" class="select-wrap">-->
<!--                <select name="projectSelect" id="projectSelect" v-model="formProject">-->
<!--                    <option value="" disabled selected hidden>Select Your Project</option>-->
<!--                    <option v-if="project.active" v-for="project in projectList" :value="project">{{project.name}}</option>-->
<!--                </select>-->
<!--            </label>-->
<!--            <div id="projectDesc" v-if="this.formProject !== ''">-->
<!--                <p>{{formProject.desc}}</p>-->
<!--                <p v-if="this.formProject.total_donated > 0">Together, we have raised-->
<!--                    ${{formProject.total_donated.toFixed(2)}} for this project, leading to {{roundToDecimal(formProject.num_completed, 1)}}-->
<!--                    {{formProject.unit_name}}.</p>-->
<!--                <p v-if="this.formProject.total_donated === 0">Be the first to donate to this project!</p>-->
<!--            </div>-->
<!--        </div>-->
<!--        <project-select :project="formProject" @project-change="formProject = $event"></project-select>-->
        <div id="AboutButton">
            <a href="https://nicc-tico2e.getresponsesite.com/" target="_blank" class="button-submit"><span><span class="title"><img
                src="../../assets/NICC-_Favicon-White.png" alt="" class="nicc-icon"> Read More About</span> The National Indian Carbon Coalition's Forest Carbon Projects</span></a>
        </div>

        <payment-box v-if="calculations_done" :payment="offsetCost" :callback="paymentCompleted"></payment-box>
        <sponsor-info v-if="this.event && this.event.sponsor" :name="event.sponsor.name" :message="event.sponsor.message" :logo="event.sponsor.logo"></sponsor-info>
    </div>
</template>

<script>
    /* global google */
    // import Vuex from "vuex";
    import axios from "axios";
    import PaymentBox from "../PaymentBox";
    import SponsorInfo from "../SponsorInfo";
    import formatting from "../../mixins/formatting";
    import ProjectSelect from "../form-elements/ProjectSelect";

    export default {
        name: "EventPay",
        components: {PaymentBox, SponsorInfo, ProjectSelect},
        mixins: [formatting],
        data() {
            return {
                anonymous: false,
                distance: 0, // Distance, in meters. Get mileage using this.miles
                travel: "airplane",
                rooms: 1, // Rooms used at the hotel. Always 1 until further notice
                projectList: {},
                recurring: false,
                payment: 0,
                payment_min: 10,
                payment_recommended: 25,
                default_min: 10, // Payment will never be able to be lower than this.
                default_recommended: 25,
                event: {},
                showError: false,
                credentials: {
                    sandbox: "AQQFd9IC6APOKL2bFjAOIvHrQL7GuTy56aXUi4UzpMxqhyhE0jnuvgbnb5h-sGtICnw7YwlzKuEmIOzA",
                    production: "AVpfVc-igcw4Cl7Kh5r4fmTSS0MfvHARuTxWjocy64R8rUYYyH-e8Ttksk7y7TCK68hK78NL2lmGoU22"
                },
                paypalStyle: {
                    label: 'checkout',
                    size: 'responsive',          // small | medium | large | responsive
                    shape: 'rect',         // pill | rect
                    color: 'blue'         // gold | blue | silver | black
                },
                invalidCar: false,
                valid_form: false,
                calculations_done: false
            };
        },
        computed: {
            // ...Vuex.mapState(['travelFormData']),
            formTravel() {
                return this.$store.getters["travelFormData/travel"];
            },
            formProject: {
                get() {
                    return this.$store.getters["travelFormData/project"];
                },
                set(value) {
                    this.$store.commit("travelFormData/setProject", value);
                }
            },
            miles() {
                return this.distance * 0.000621371 * 2; // Double the conversion because it's a round trip
            },
            co2() { // tons of CO2
                let total;
                switch (this.travel) {
                case "airplane":
                    total = this.airCo2;
                    break;
                case "car":
                    total = this.landCo2;
                    break;
                default:
                    console.error("Unknown travel type " + this.travel);
                }
                return total + this.hotelCo2;
            },
            lbsCo2() {
                return this.co2 * 2204.623;
            },
            airCo2() {
                return this.miles * 0.0002738534;
            },
            landCo2() {
                // Number of driven miles (miles) * (1 gal/22 miles) * (8.84 kg CO2e / gal) * (1 MTCO2e / 1,000 kg CO2e)
                return this.miles / 22 * 8.887 / 1000;
            },
            hotelCo2() {
                //  GHG Eq for nights = 26.6 kg CO2 per room day * (1 MTCO2e / 1,000 kg CO2e)* (Number of Nights + 1)Days * 1 room
                if (this.$store.getters["travelFormData/hotel"] === 0) {
                    return 0;
                }
                return 26.6 / 1000 * (this.$store.getters["travelFormData/hotel"] + 1) * this.rooms;
            },
            trees() {
                return this.co2 * 16.535211733386;
            },
            offsetCost() {
                return this.co2 * 17.16;
            }
        },
        mounted() {
            if (!this.$store.getters["travelFormData/isset"]) {
                console.log(this.$store.getters["travelFormData/isset"]);
                this.$router.push("/");
                return;
            }
            this.setup();
        },
        watch: {
            "$route": function(to, from) {
                if (!this.$store.getters["travelFormData/isset"]) {
                    this.$router.push("/");
                    return;
                }
                this.setup();
            }
        },
        methods: {
            async paymentCompleted(e, fName, lName, email, anon) {
                // console.log("Payment complete. Object returned:");
                // console.log(e);
                if (e.state !== "approved") {
                    this.showError = true;
                    return;
                }
                let startLocation, endLocation;
                if (this.$store.getters["travelFormData/departure"].locality) {
                    startLocation = this.$store.getters["travelFormData/departure"].locality;
                } else if (this.$store.getters["travelFormData/departure"].administrative_area_level_1) {
                    startLocation = this.$store.getters["travelFormData/departure"].administrative_area_level_1;
                } else {
                    startLocation = this.$store.getters["travelFormData/departure"].country;
                }
                if (this.$store.getters["travelFormData/arrival"].locality) {
                    endLocation = this.$store.getters["travelFormData/arrival"].locality;
                } else if (this.$store.getters["travelFormData/arrival"].administrative_area_level_1) {
                    endLocation = this.$store.getters["travelFormData/arrival"].administrative_area_level_1;
                } else {
                    endLocation = this.$store.getters["travelFormData/arrival"].country;
                }
                let options = {
                    event_id: this.event.id,
                    project_id: this.formProject.id,
                    start_location: startLocation,
                    end_location: endLocation,
                    travel_type: this.travel,
                    distance: this.miles,
                    anon: anon,
                    recurring: false,  // TODO: What do?
                    nights: this.$store.getters["travelFormData/hotel"],
                    co2: this.co2,
                    paypal_id: e.id,
                    payer_id: e.payer.payer_info.payer_id,
                    amount: e.transactions[0].amount.total,
                    email: email,
                    first_name: fName,
                    last_name: lName
                };
                if (this.$store.getters["user/isSet"]) {
                    options.user_id = await this.$store.getters["user/getItem"]("id");
                }
                console.log(options);
                axios.post(this.$store.getters["server"] + "/create-contribution", options)
                .then(() => {
                    this.$store.commit("travelFormData/reset");
                    this.$router.push("/travel/paycomplete");
                });
            },
            getDistanceMatrix(service, data) {
                console.log("requesting distance matrix");
                return new Promise((resolve, reject) => {
                    service.getDistanceMatrix(data, (response, status) => {
                        if (status === 'OK') {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    });
                });
            },
            async getAutoDistance(start, end) {
                console.log("getting distance");
                const service = new google.maps.DistanceMatrixService();
                const result = await this.getDistanceMatrix(
                    service,
                    {
                        origins: [start],
                        destinations: [end],
                        travelMode: 'DRIVING'
                    }
                );
                if (result.rows[0].elements[0].distance) {
                    return result.rows[0].elements[0].distance.value;
                }
                return false;
            },
            async setup() {
                this.projectList = await axios.get(this.$store.getters["server"] + "/projects", {headers: {"Access-Control-Allow-Origin": this.$store.getters["server"]}})
                    .then((data) => {
                        console.log(data.data.projects);
                        return data.data.projects;
                    });
                if (await this.$auth.isAuthenticated() && this.$store.getters["user/isSet"]) {
                    this.fName = await this.$store.getters["user/getItem"]("first_name");
                    this.lName = await this.$store.getters["user/getItem"]("last_name");
                    this.email = await this.$store.getters["user/getItem"]("preferred_username");
                }
                this.travel = this.$store.getters["travelFormData/travel"];
                this.event = this.$store.getters["travelFormData/event"];
                this.showError = false;
                this.distance = await this.getDistance(this.travel);
                if (this.payment < this.payment_recommended) {
                    this.payment = this.payment_recommended;
                }
                this.calculations_done = true;
            },
            async getDistance(travelMethod) {
                let departure = this.$store.getters["travelFormData/departure"];
                let arrival = this.$store.getters["travelFormData/arrival"];
                this.invalidCar = false;
                if (travelMethod !== "car" && travelMethod !== "airplane") {
                    console.error("Unknown travel type " + this.travel);
                }
                let traveldata;
                if (travelMethod === "car") {
                    traveldata = await this.getAutoDistance(new google.maps.LatLng(departure.latitude, departure.longitude), new google.maps.LatLng(arrival.latitude, arrival.longitude));
                    if (traveldata) {
                        return traveldata;
                    }
                    this.invalidCar = true;
                }
                let value = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(departure.latitude, departure.longitude), new google.maps.LatLng(arrival.latitude, arrival.longitude));
                console.log(value);
                return value;
            },
            getOffsetCostWrapScale() {
                let wrap = this.$refs.offsetCostWrap;
                if (wrap) {
                    let contentWidth = this.$refs.offsetCostIcon.offsetWidth + this.$refs.offsetCostText.offsetWidth;
                    if (contentWidth > wrap.offsetWidth) {
                        return wrap.offsetWidth / contentWidth * 0.8; // 0.8 is a buffer, because I can't include margins
                    }
                    return 1;
                }
                return 1;
            }
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../../assets/variables";

    #estimateExplanation{
        margin: 1.6em 0;
    }

    #calculatedValues {
        padding: 0 0 1rem;
        margin: 0 0 1rem;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    #calculatedOffsetCostWrap {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #calculatedOffsetIcon {
        font-size: 7.5rem;
        position: relative;

        .dollar-overlay {
            color: white;
            font-weight: 700;
            font-size: 0.47em;
            position: absolute;
            top: 30%;
            left: 36%;
        }
    }

    .calc-value{
        color: @text-color;
        font-size: 1.5rem;
        font-family: "Lora", serif;
        font-weight: 700;
    }

    #calculatedOffsetCost {
        text-align: left;
        position: relative;
        top: -0.5rem;
        margin-left: 1rem;
        font-size: 5rem;
    }

    #calculatedOffsetTotal {
        font-family: "Lora", serif;
        font-weight: 700;
    }

    #calculatedOffsetSubtitle{
        text-transform: uppercase;
        color: @light-gray;
        font-weight: bold;
        letter-spacing: 0.05em;
        font-size: 0.2em;
    }

    .calculated-item {
        .icon-caption {
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: @light-gray;
        }

        .co2-overlay {
            font-size: 1.2rem;
            color: white;
            position: absolute;
            width: 100%;
            top: 1.25em;
            text-align: center;
            font-weight: 700;
        }
    }

    .calculated-icon {
        text-align: center;
        font-size: 3.5rem;
        position: relative;
        color: @orange;
    }

    #notRecurring {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    img.nicc-icon {
        height: 1em;
    }
    #AboutButton {
        margin: 2rem auto ;
        padding: 0;
        max-width: 22em
    }

</style>



// WEBPACK FOOTER //
// src/components/travel-calculator/EventPay.vue